import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CheckboxList from './CheckboxList';
import ClientProvider from './client';
export default createDemo(import.meta.url, CheckboxList, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/lists/demos/checkbox/CheckboxList.tsx",
    "fileName": "CheckboxList.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport IconButton from '@mui/material/IconButton';\nimport CheckBoxIcon from '@mui/icons-material/CheckBox';\nimport CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';\nimport CommentIcon from '@mui/icons-material/Comment';\n\nexport default function CheckboxList() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [checked, setChecked] = React.useState([0]);\n\n  const handleToggle = (value: number) => () => {\n    const currentIndex = checked.indexOf(value);\n    const newChecked = [...checked];\n\n    if (currentIndex === -1) {\n      newChecked.push(value);\n    } else {\n      newChecked.splice(currentIndex, 1);\n    }\n\n    setChecked(newChecked);\n  };\n\n  return (\n    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>\n      {[0, 1, 2, 3].map((value) => {\n        const labelId = `checkbox-list-label-${value}`;\n        const labelValue = `Line item ${value + 1}`;\n        const isChecked = checked.includes(value);\n        const SelectionIcon = isChecked ? CheckBoxIcon : CheckBoxOutlineBlankIcon;\n\n        return (\n          <ListItem\n            key={value}\n            secondaryAction={\n              <IconButton edge=\"end\" aria-label={`see comments for ${labelValue}`}>\n                <CommentIcon />\n              </IconButton>\n            }\n            disablePadding\n          >\n            <ListItemButton\n              role=\"checkbox\"\n              aria-checked={isChecked}\n              aria-labelledby={labelId}\n              onClick={handleToggle(value)}\n              dense\n            >\n              <ListItemIcon>\n                <SelectionIcon\n                  sx={{\n                    color: isChecked ? 'primary.main' : 'text.secondary',\n                    padding: '9px',\n                    marginLeft: '-12px',\n                    boxSizing: 'content-box',\n                  }}\n                />\n              </ListItemIcon>\n              <ListItemText id={labelId} primary={labelValue} />\n            </ListItemButton>\n          </ListItem>\n        );\n      })}\n    </List>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 70,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport List from '@mui/material/List';\nimport ListItem from '@mui/material/ListItem';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemIcon from '@mui/material/ListItemIcon';\nimport ListItemText from '@mui/material/ListItemText';\nimport IconButton from '@mui/material/IconButton';\nimport CheckBoxIcon from '@mui/icons-material/CheckBox';\nimport CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';\nimport CommentIcon from '@mui/icons-material/Comment';\n\nexport default function CheckboxList() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [checked, setChecked] = React.useState([0]);\n\n  const handleToggle = (value: number) => () => {\n    const currentIndex = checked.indexOf(value);\n    const newChecked = [...checked];\n\n    if (currentIndex === -1) {\n      newChecked.push(value);\n    } else {\n      newChecked.splice(currentIndex, 1);\n    }\n\n    setChecked(newChecked);\n  };\n\n  return (\n    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>\n      {[0, 1, 2, 3].map((value) => {\n        const labelId = `checkbox-list-label-${value}`;\n        const labelValue = `Line item ${value + 1}`;\n        const isChecked = checked.includes(value);\n        const SelectionIcon = isChecked ? CheckBoxIcon : CheckBoxOutlineBlankIcon;\n\n        return (\n          <ListItem\n            key={value}\n            secondaryAction={\n              <IconButton edge=\"end\" aria-label={`see comments for ${labelValue}`}>\n                <CommentIcon />\n              </IconButton>\n            }\n            disablePadding\n          >\n            <ListItemButton\n              role=\"checkbox\"\n              aria-checked={isChecked}\n              aria-labelledby={labelId}\n              onClick={handleToggle(value)}\n              dense\n            >\n              <ListItemIcon>\n                <SelectionIcon\n                  sx={{\n                    color: isChecked ? 'primary.main' : 'text.secondary',\n                    padding: '9px',\n                    marginLeft: '-12px',\n                    boxSizing: 'content-box',\n                  }}\n                />\n              </ListItemIcon>\n              <ListItemText id={labelId} primary={labelValue} />\n            </ListItemButton>\n          </ListItem>\n        );\n      })}\n    </List>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 70,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/List",
      "@mui/material/ListItem",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemIcon",
      "@mui/material/ListItemText",
      "@mui/material/IconButton",
      "@mui/icons-material/CheckBox",
      "@mui/icons-material/CheckBoxOutlineBlank",
      "@mui/icons-material/Comment"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
